var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarouselRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 99,
    viewBox: "0 0 56 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3293 63.995L4.70167 81.75H0.567443L17.4581 64.7302V34.2698L0.567443 17.25H4.70167L22.3293 35.0049V39.1708V59.8218V63.995ZM4.34057 22.8936H2.40979L15.1809 35.755V63.245L2.40979 76.1139H4.3332L16.36 63.995V59.8292V39.1782V35.0124L4.34057 22.8936ZM16.3379 49.5L16.36 49.448H16.3085L4.45111 22.9455H0L11.2015 49.5L0 76.0545H4.45111L16.3158 49.552H16.3674L16.3379 49.5ZM33.9139 27.297V33.3787L49.9718 49.5594L33.9139 65.7327V71.8144L56 49.5594L33.9139 27.297ZM11.8205 11.1609L0.744308 0H7.59784L18.674 11.1609H11.8205ZM18.674 87.8391L7.59784 99H0.744308L11.8205 87.8391H18.674ZM47.3041 49.552L30.6051 66.3861V32.7178L47.3041 49.552ZM48.019 49.5L31.9684 65.6807V70.8787L17.4065 85.5445H11.9532L3.55205 94.0025H1.59179L45.7565 49.5L1.78339 5.19059H4.67956L11.9532 12.5198H16.478L31.9684 28.1287V33.3267L48.019 49.5Z",
    fill: "#FFF600"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselRightArrow);
export default __webpack_public_path__ + "static/media/carousel-right-arrow.704d061a.svg";
export { ForwardRef as ReactComponent };